
// TODO: Get values from client_area_field_value where  key = business-age
export const enum BusinessLength {
    MONTH_LESS_THEN_6 = 203,
    YEAR_LESS_THEN_1 = 134,
    YEAR_1 = 135,
    YEAR_2 = 136,
    YEAR_3_4 = 198,
    YEAR_5_7 = 137,
    YEAR_8_10 = 138,
    YEAR_11_13 = 199,
    YEAR_14_17 = 200,
    YEAR_18_20 = 201,
    YEAR_MORE_20 = 202,
}

export const enum DebtAccount {
    NO_ACTIVE_ACCOUNT = 126,
    DEBT_ACCOUNT_CREATED = 127,
    PENDING_REPAYMENT = 128,
    CLOSED = 129,
    REPAID = 154,
    WRITTEN_OFF = 155,
    PENDING_REPAYMENT_INKAS = 172,
    PENDING_REPAYMENT_SPLIT_SETTLEMENT = 182,
    PENDING_REPAYMENT_COLLECTIONS = 183
}

export const enum DebtAccountPending {
    PENDING_REPAYMENT = 128,
    PENDING_REPAYMENT_INKAS = 172,
    PENDING_REPAYMENT_SPLIT_SETTLEMENT = 182
}


export const enum TimeFrame {
    IMMEDIATELY = 1,
    DAY_30 = 2,
    DAY_60 = 3,
    DAY_MORE_THEN_90 = 4,
    NOT_SURE = 5
}

export const enum Purpose {
    EXPANSION = 1,
    RENOVATIONS = 2,
    INVENTORY = 3,
    CASH_FLOW = 4,
    TAXES = 5,
    RENT = 6,
    OTHER = 7
}


export enum ClientStatusType {
    INCOMPLETE = 1,
    IN_DATA_ENTRY = 2,
    IN_UNDERWRITING = 3,
    APPROVED_NOT_FUNDED = 4,
    DECLINED = 5,
    FUNDED = 6,
    NEW_CLIENT = 7,
    STATEMENT_NOT_PRICED = 9,
    WAITING_ON_STATEMENT = 10,
    NO_ANSWER = 11,
    NOT_AVAILABLE = 12,
    NOT_INTERESTED = 13,
    NOT_NOW_IN_THE_FUTURE = 14,
    NOT_IN_SERVICE = 15,
    OUT_OF_BUSINESS = 16,
    SELLING_BUSINESS = 17,
    SCHEDULED_CALL_BACK = 18,
    STATEMENT_PRICED = 21,
    AGREEMENT_OUT = 22,
    AGREEMENT_IN = 23,
    COMPLETE = 24,
    APPROVED_BY_DE = 25,
    SEASONAL = 31,
    EXPIRED = 32,
    NON_QUALIFIED = 33,
    LOW_VOLUME = 34
}

export const enum ClientsReasonType {
    TOO_EXPENSIVE = 1,
    DOESNT_NEED_MONEY = 2,
    SELLING_BUSINESS_REASON = 3,
    RETIRING = 4,
    RECEIVED_MONEY_ELSEWHERE = 5,
    NOT_ENOUGHT_MONEY = 6,
    WITHHOLDING = 7,
    NO_PURPOSE = 8,
    CLOTHING_BUSINESS = 9,
    OTHER_REASON = 10
}



// WEBPACK FOOTER //
// ./src/app/models/clients/clients.type.ts